import moment from 'moment'

UAGenerateUseCodesCtrl.$inject = ['userUuids', 'domainUuid', 'adminApi', '$uibModalInstance']

export default function UAGenerateUseCodesCtrl(userUuids, domainUuid, adminApi, $uibModalInstance) {
  this.userUuids = userUuids
  this.domainUuid = domainUuid
  this.useCodeExpiration = moment()
    .add(1, 'months')
    .toDate()
  this.loading = false
  this.successful = false
  this.errorMessage = null

  this.generateCodes = function() {
    this.loading = true
    this.errorMessage = null
    adminApi
      .generateDomainUseCodes(
        this.domainUuid,
        this.userUuids,
        moment(this.useCodeExpiration).format('YYYY-MM-DD')
      )
      .then(
        resp => {
          this.loading = false
          this.successful = true
        },
        err => {
          console.error(err)
          this.errorMessage = `Error: ${err.data}`
          this.loading = false
        }
      )
  }
}
